import React, { useState, useEffect } from "react";
import * as API from '../../../framework/API/api';
import { utility } from "../../../framework/utility/utilityProvider";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { useTranslation } from "../../../locale/useTranslation";
import ToastNotification from "../../../components/ToastNotification";
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, MAM_STATUS, TOAST_TYPES, TRANSMISSION_ACTION, TRANSMISSION_ACTIVE_STATUS } from "../../../framework/constant/constant";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import MyStatusCell from "../../../components/MyStatusCell";
import MAMStatusCell from "../../../components/MAMStatusCell";
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { TransmissionTypeStatusCell } from "../../../components/TransmissionTypeStatusCell";

const VODActivityReport = () => {

    const defaultDates = utility.getFirstAndLastDateOfMonth();
    const lang = useTranslation();

    const blankDataItem = {
        fromDate: defaultDates.FirstDate,
        toDate: defaultDates.LastDate
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [thumbnailData, setThumbnailData] = useState([]);
    const [transmissionData, setTransmissionData] = useState([]);
    const [tabNumber, setTabNumber] = React.useState("1");
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        loadGridColumns();
    }, []);

    const loadGridColumns = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);

        const columns = await API.getFormData(
            ENTITYNAME.Transmissions,
            currentUserId
        );

        setDataColumns(columns ?? []);
    };

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const isValid = () => {
        if (dataItem.fromDate == undefined || dataItem.fromDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (dataItem.toDate == undefined || dataItem.toDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.toDate < dataItem.fromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        return true
    }

    const loadData = async () => {
        if (!isValid()) return;
        setIsLoading(true);
        setLoadingStatus(lang.data_loading_error_message);
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);
        setDataColumns(columns ?? []);
        setTransmissionData([]);
        setThumbnailData([]);

        const payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringDatetoMilliseconds(dataItem.toDate) : null,
            isExport: false
        };

        const res = await API.getVodActivityReport(payload);
        if (res.success) {

            setTransmissionData(res?.data?.transmissionData);
            setThumbnailData(res?.data?.thumbnailData ?? []);
            setLoadingStatus(lang.no_record_found_error_message);
        } else {
            setTransmissionData([]);
            setThumbnailData([]);
            setLoadingStatus(lang.no_record_found_error_message);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsLoading(false);
    };

    const downloadExcel = async () => {
        if (!isValid()) return;

        let columns = dataColumns;
        if (!columns || columns.length === 0) {
            let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);
            columns = columns ?? [];
            setDataColumns(columns);
        }
        let payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringDatetoMilliseconds(dataItem.toDate) : null,
            isExport: true,
            columns: columns.map(col => ({ name: col.name, label: col.label, type: col.type, format: col.format }))
        }
        var res = await API.getVodActivityReport(payload);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const actionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTION, dataItem?.action);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.action) {
            case TRANSMISSION_ACTION.Published:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTION.Delete:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTION.Create:
                title = title;
                tileBackColor = "#3B82F6";
                break;
            case TRANSMISSION_ACTION.Update:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }
        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const transmissionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, dataItem?.status);
        let tileBackColor = "";
        let titleColor = "white";
        switch (dataItem?.status) {
            case TRANSMISSION_ACTIVE_STATUS.Active:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTIVE_STATUS.InActive:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTIVE_STATUS.Upcoming:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }
        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const thumbnailStatusCell = (props) => {
        const { dataItem } = props;

        let title = dataItem?.IsThumbnailProcessed ? "Processed" : "Pending";
        let tileBackColor = dataItem?.IsThumbnailProcessed ? "#63AA43" : "#E72929";
        let titleColor = "white";

        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const mamHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(`/home/mamAssets?mamID=${value}`, '_blank')}>{value}</div>
            </td>
        )
    }

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.vod_activity_report_header}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="row">
                    <div className="col-3">
                        <label className="form-label">{lang.from_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="fromDate" value={dataItem.fromDate} onChange={onChange} />
                    </div>
                    <div className="col-3">
                        <label className="form-label">{lang.to_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="toDate" value={dataItem.toDate} onChange={onChange} />
                    </div>
                    <div className="col mt-4">
                        <ActionButton name={lang.show_button_text} onClick={loadData} isLoading={isLoading} />
                        <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Box sx={{ width: "100%" }}>
                            <TabContext value={tabNumber}>
                                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                        <Tab label={lang.transmissions_label} value="1" />
                                        <Tab label={lang.thumbnails_label} value="2" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <Grid
                                        style={{ height: 'calc(107vh - 300px)', overflow: 'auto' }}
                                        resizable={true}
                                        data={transmissionData}
                                    >
                                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                                        {dataColumns.map((column, index) => {
                                            if (column.type === COLUMNSTYPE.date) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={DateOnlyCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.type === COLUMNSTYPE.datetime) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={DateCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={TimeCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.name === "SID") {
                                                return;
                                            }
                                            else if (column.type === COLUMNSTYPE.array) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={ArrayCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        format={column.format ?? "Description"}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={TransmissionTypeStatusCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.label === "Title") {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        format={column.format}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.mamStatus) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={MAMStatusCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={LocalDateTimeColumn}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.label === "MAM ID") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={mamHyperLinkCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "status") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={transmissionStatusCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "action") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={actionStatusCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "IsThumbnailProcessed") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={thumbnailStatusCell}
                                                        width={column.width ?? 130}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else {
                                                return (
                                                    column.type !== COLUMNSTYPE.hidden && (
                                                        <GridColumn
                                                            key={index}
                                                            field={column.name}
                                                            title={column.label}
                                                            width={column.width ?? 200}
                                                            sortable={true}
                                                        />
                                                    )
                                                );
                                            }
                                        })}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2">
                                    <Grid data={thumbnailData} style={{ height: '60vh' }} resizable={true}>
                                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                                        <GridColumn field="CSID" title={lang.transmission_id_column} width={"150"} />
                                        <GridColumn field="contentId" title={lang.content_id_column} width={"150"} />
                                        <GridColumn field="title" title={lang.title_column} width={"180"} />
                                        <GridColumn field="episodeNumber" title={lang.episode_number_label} width={"140"} />
                                        <GridColumn field="IsThumbnailProcessed" title={lang.thumbnail_status_column} width={"150"} cell={thumbnailStatusCell} />
                                        <GridColumn field="thumbnailFilename" title={lang.thumbnail_filename_column} width={"220"} />
                                        <GridColumn field="thumbnailProcessedOn" title={lang.thumbnail_process_on_column} width={"200"} />
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default VODActivityReport;